import { Menu, Search } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useCommandCenter } from '../command/CommandCenter';

interface HeaderProps {
  isMobile?: boolean;
  onMenuClick?: () => void;
}

const PAGE_TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/users': 'Users',
  '/events': 'Events',
  '/venues': 'Venues',
  '/vendors': 'Vendors',
  '/photos': 'Photos',
  '/profile': 'My Profile',
  '/tasks': 'Tasks',
  '/assistant': 'Assistant',
  '/checklists': 'Tasks',
};

/**
 * The app bar: the mobile menu button and the page title.
 *
 * The notification bell used to live here. It moved to the foot of the sidebar
 * (`ConversationsBell`) when it grew a conversations tab — a dropdown listing
 * threads wants to open beside the navigation it belongs to, not from the
 * far corner of a wide screen.
 */
export function Header({ isMobile, onMenuClick }: HeaderProps) {
  const location = useLocation();
  const title = PAGE_TITLES[location.pathname] || '';
  const commands = useCommandCenter();

  return (
    <header className="bg-white border-b border-gray-200 px-4 md:px-6 py-3 md:py-4 flex items-center gap-3">
      {isMobile && (
        <button
          onClick={onMenuClick}
          className="p-1 text-gray-600 hover:text-gray-900"
          aria-label="Open menu"
        >
          <Menu size={24} />
        </button>
      )}
      {isMobile && title && <h1 className="text-lg font-semibold text-gray-900">{title}</h1>}
      {/* No keyboard on a phone, so search needs a button of its own here. */}
      {isMobile && commands.available && (
        <button
          onClick={commands.openSearch}
          className="ml-auto p-1 text-gray-600 hover:text-gray-900"
          aria-label="Search"
        >
          <Search size={22} />
        </button>
      )}
    </header>
  );
}
